import * as React from 'react';
import { styled } from '@glitz/react';
import { Button } from 'webapp/components/button';
import { FieldSize } from 'webapp/components/field-size';
import { setComponentState, useMatchLargeViewport } from '@avensia/excite';
import { Theme } from 'webapp/theme';

type HeaderPropType = {
  isActive?: boolean;
  index: number;
  disabled?: boolean;
  children: React.ReactNode;
  onSelectedTabChanged: (index: number) => void;
};

export const tabComponentId = 'tabComponent';

export default function TabHeader(props: HeaderPropType) {
  const { index, isActive, onSelectedTabChanged, children } = props;
  const isLargeViewport = useMatchLargeViewport();

  const onClick = React.useCallback(() => {
    onSelectedTabChanged(index);
    setComponentState({ id: tabComponentId, state: index });
  }, [index, onSelectedTabChanged]);

  return (
    <TabButton
      size={isLargeViewport ? FieldSize.Default : FieldSize.Small}
      as={isActive ? Theme.Monochrome : Theme.White}
      onClick={onClick}
    >
      {children}
    </TabButton>
  );
}

const TabButton = styled(Button, {
  flexShrink: 0,
});
